/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Table: Master inventory records
************************************************************************/
import React from 'react';
import moment from 'moment';
import CultivationModal from '../cult_modal';
import TreeReplantDisplay from './tree_replant_display';
import TreeReplantForm from './tree_replant_form';
import { packageForm } from '../../cult_utils';

const TreeReplantTable = ({ replants, fields, employees, inventoryTransactions, addedEmployees, user, addEmployeeToEdit, 
  removeEmployeeFromEdit, fetchFields, editing, setReplantToEdit, setReplantToDelete, editReplant, deleteReplant, 
  readOnly, onClick }) => {
  if (replants.length === 0) return <div></div>;
  if (readOnly) {
    return (
      <table className="highlight bordered centered responsive-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Location</th>
            <th>Field</th>
            <th>Total Trees</th>
            <th>Trees Planted</th>
            <th>Trees Remaining</th>
            <th>Hours</th>
            <th>Trees / Hour</th>
            <th>Employees</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {
            replants.map((r) => (
              <tr key={r.id}>
                <td>{ moment(r.date).format('MM/DD/YYYY') }</td>
                <td>{ r.location }</td>
                <td>{ r.field }</td>
                <td>{ r.totalTrees }</td>
                <td>{ r.treesPlanted }</td>
                <td>{ r.treesRemaining }</td>
                <td>{ r.hours }</td>
                <td>{ r.treesPerHour }</td>
                <td>
                  { r.employees.map((e) => (
                     <span key={e.eid}><b>{e.name}</b>, {e.position} <br /></span> 
                    )) 
                  }
                </td>
                <td>{ Number(r.isComplete) === 0 ? <span className="label label-incomplete">Incomplete</span>
                              : <span className="label label-complete">Complete</span>
                    }
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }
  return (
    <table className="highlight bordered centered responsive-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Location</th>
          <th>Field</th>
          <th>Total Trees</th>
          <th>Trees Planted</th>
          <th>Trees Remaining</th>
          <th>Hours</th>
          <th>Trees / Hour</th>
          <th>Employees</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {
          replants.map((r) => (
            <tr key={r.id}>
              <td>{ moment(r.date).format('MM/DD/YYYY') }</td>
              <td>{ r.location }</td>
              <td>{ r.field }</td>
              <td>{ r.totalTrees }</td>
              <td>{ r.treesPlanted }</td>
              <td>{ r.treesRemaining }</td>
              <td>{ r.hours }</td>
              <td>{ r.treesPerHour }</td>
              <td>
                { r.employees.map((e) => (
                   <span key={e.eid}><b>{e.name}</b>, {e.position} <br /></span> 
                  )) 
                }
              </td>
              <td>{ Number(r.isComplete) === 0 ? <span className="label label-incomplete">Incomplete</span>
                            : <span className="label label-complete">Complete</span>
                  }</td>
              <td>
                <ul className="btn-actions">
                  <li className="action-btn-li">
                    <a className="btn-floating blue pointer modal-trigger tooltipped btn-squared" href={`#${r.id}-edit`}
                      onClick={() => setReplantToEdit({ replant: r, formId: `tree-replant-editForm-${r.id}` })}  data-position="left" data-tooltip="Edit">
                      <i className="material-icons">mode_edit</i>
                    </a>
                  </li>
                  <li className="action-btn-li">
                    <a className={`btn-floating red pointer modal-trigger tooltipped btn-squared`} href={`#${r.id}-delete`}
                      onClick={() => setReplantToDelete(r)} data-position="top" data-tooltip="Delete">
                      <i className="material-icons">clear</i>
                    </a>
                  </li>
                </ul>
                { 
                  CultivationModal(TreeReplantForm)
                  // eslint-disable-next-line
                  ({
                    id: `${r.id}-edit`,
                    formId: `tree-replant-editForm-${r.id}`,
                    fields, 
                    employees,
                    inputId: r.id, 
                    inventoryTransactions, 
                    addedEmployees,
                    addEmployee: addEmployeeToEdit, 
                    removeEmployee: removeEmployeeFromEdit, 
                    fetchFields,
                    toDelete: false, 
                    editing,
                    footer: true,
                    createOrEdit: true,
                    onClick: () => editReplant({ 
                      data: packageForm(`tree-replant-editForm-${r.id}`), 
                      user, 
                      oldReplantRecord: r,
                      addedEmployees,
                      formId: `tree-replant-editForm-${r.id}` 
                    })
                  })
                }
                {
                  
                  CultivationModal(TreeReplantDisplay)
                  // eslint-disable-next-line
                  ({
                    id: `${r.id}-delete`,
                    data: { ...r, addedEmployees: r.employees },
                    inventoryTransactions,
                    prevReplants: [],
                    toDelete: true, 
                    editingApplication: false,
                    footer: true,
                    createOrEdit: true,
                    onClick: () => deleteReplant(r)
                  })
                  
                }
              </td>
            </tr>
          ))
        }
      </tbody>
    </table>
  )
}

export default TreeReplantTable;





























/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_replant_table.js